import { useSelector } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Spinner from '../components/Spinner/Spinner';
import { redux } from '../reduxService';
import { useAppDispatch } from '../reduxService/hooks';
import './localization';
import CommonRoutes, { endpoint } from './pages';
import PageNotFound from './pages/Error/Error';
import { cleanProjectInfo } from './store/projectInfo/projectInfoSlice';
import { fetchUser, selectUser } from './store/user/userSlice';
import { restoreFromSession, selectIsAuthenticated } from './store/auth/authSlice';
import LoginForm from './components/LoginForm/LoginForm';
import { isAuthenticationRequired } from './utils/authUtils';
import ErrorBoundary from '../errorBoundary/ErrorBoundary';

// App component props interface reserved for future extension
type IApp = Record<string, never>;

redux.dispatch(restoreFromSession());

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const App = (props: IApp) => {
    const user = useSelector(selectUser);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    // Check if authentication is required for this environment
    const requiresAuth = isAuthenticationRequired();

    // Fetch user data on mount and when authentication status changes
    useEffect(() => {
        if (!requiresAuth || isAuthenticated) {
            dispatch(fetchUser());
        }
    }, [isAuthenticated, requiresAuth, dispatch]);

    const navigateAfterError = () => {
        dispatch(cleanProjectInfo());
        /*     dispatch(cleanProject()); */
        navigate(endpoint.home);
    };

    // Show login form only if authentication is required AND user is not authenticated
    if (requiresAuth && !isAuthenticated) {
        return <LoginForm />;
    }

    return (
        <ErrorBoundary navigate={navigateAfterError}>
            {!user.initialState && !user.pending && !!user.data ? (
                <Routes>
                    {CommonRoutes}
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            ) : (
                <Spinner />
            )}
        </ErrorBoundary>
    );
};

export default App;
